import { fetchToken, play } from "../livekit";

const apiMiddleware = (store) => (next) => async (action) => {
  switch (action.type) {

    case 'livekit/setActiveInstructor': // Replace with your actual action type
      try {

        const authData = store.getState().auth;
        console.log('authData', authData);
        // Await the fetchToken promise
        let data = {
          instructor: null,
          userId: null,
          hasCourse: null,
          tokenData: authData.token
        }
        if (action.payload == "male" || action.payload == "female") {
          data = {
            instructor: authData.token.botName,
            userId: authData.token ? authData.token.userId : null,
            hasCourse: false,
            tokenData: authData.token,
            isCustomBot: true
          }
        } else {
          data = {
            instructor: action.payload,
            userId: authData.token ? authData.token.userId : null,
            hasCourse: authData.token ? true : false,
            tokenData: authData.token,
            isCustomBot: false
          }
        }
        await store.dispatch(fetchToken(data));

        // Dispatch play action after fetchToken completes
        store.dispatch(play());
      } catch (error) {
        console.error("Error fetching token:", error);
        // Optionally dispatch an error action or handle the error as needed
      }
      next(action); // Call next with the action
      break;
    default:
      next(action); // Call next with the action
      break;
  }
};

export default apiMiddleware;
